// extracted by mini-css-extract-plugin
export default {"fpWrapper":"LayoutWithSidebar_fpWrapper__B1cUJ","sidebar":"LayoutWithSidebar_sidebar__pryjh","fpPanelMain":"LayoutWithSidebar_fpPanelMain__zeEZA"};